<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-evgGoodsReview',
  components: { PageTable },
}
</script>
